import { render, staticRenderFns } from "./form-resume.vue?vue&type=template&id=7d7ec7ba"
import script from "./form-resume.vue?vue&type=script&lang=js"
export * from "./form-resume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports